<template>
    <div id="actiWrap">
        <h4 class="bg-base p-3 mt-4 mb-2 text-left">线路行程种类</h4>
        <div id="addPackage" class="pb-3">
            <div class="d-center-start mt-4">
                <left-text-border class="w-70" leftText="线路行程标题" v-model="routeInfo.name"/>
                <div class="infoPro w-80 d-center-start">
                    <div v-if="!routeInfo.file" class="ml-auto">
                        <el-progress class="ml-auto" v-if="fileProgressNum > 0" :percentage="fileProgressNum" />
                        <a v-else href="javascript:;" class="file ml-auto">上传行程单
                            <input type="file" accept=".doc,.docx,.xls,.xlsx,.pdf,.jpg,.png,.jpeg" @change="chooseFile">
                        </a>
                    </div>
                    <div v-else class="text-link ml-auto" @click="toEleMsg">{{routeInfo.file}}</div>
                </div>
            </div>
            <div class="d-center-start mt-4">
                <left-text leftText="线路行程时效" />
                <el-date-picker v-model="routeInfo.time" type="daterange" range-separator="至"
                    start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择日期" />
                <div class="d-center-start ml-5 w-50">
                    <left-text leftText="使用状态"/>
                    <el-radio v-model="routeInfo.status" :label="'1'">启用</el-radio>
                    <el-radio v-model="routeInfo.status" :label="'0'">禁用</el-radio>
                </div>
            </div>
            <div class="d-center-start mt-4">
                <left-text leftText="排序"/>
                <el-input-number size="small" v-model="routeInfo.sort" :min="1" />
                <span class="text-danger h6 ml-3">(数值越大，排名越靠前)</span>
            </div>
            <div class="d-center-start mt-4">
                <left-text leftText="活动天数" />
                <el-input class="w-10" v-model="routeInfo.day_num"><template slot="append">天</template></el-input>
                <el-input class="w-10 ml-3" v-model="routeInfo.night_num"><template slot="append">晚</template></el-input>
            </div>
            <div class="d-center mt-3 mb-3">
                <left-text leftText="线路行程价格" />
                <p class="w-50 text-center border-bottom-primary pb-1">
                <span class="text-primary">星期日</span><span class="text-danger ml-small mr-small">至</span>
                <span class="text-primary">星期四</span><span class="text-danger">（非周末）</span>
                </p>
                <p class="w-50 text-center border-bottom-primary pb-1">
                <span class="text-primary">星期五、星期六</span>
                <span class="text-danger">（周末）</span>
                </p>
            </div>
            <div class="d-center-start mb-3" v-for="(item,index) in routePrice" :key="index">
                <left-text :leftText="item.text" />
                <p class="w-50 text-center border-bottom-primary pb-1">
                    <el-input v-model="routeInfo[item.noweek]" placeholder="输入非周末价格">
                    <span slot="append" class="text-dark">元</span>
                    </el-input>
                </p>
                <p class="w-50 pl-2 text-center border-bottom-primary pb-1">
                    <el-input v-model="routeInfo[item.week]" placeholder="输入周末价格">
                    <span slot="append" class="text-dark">元</span>
                    </el-input>
                </p>
            </div>
            <div class="d-center-start mt-4">
                <left-text leftText="成团人数" />
                <el-input class="w-20" v-model="routeInfo.min"><template slot="append">人/起</template></el-input>
            </div>
            <div class="d-center-start align-items-start mt-4">
                <left-text leftText="线路行程描述" />
                <rich-editor class="w-100 special" v-model="routeInfo.description1" :nums="nums" :contentProps="routeInfo.description1" @change="change" />
            </div>
            <div class="d-center-start mt-4">
                <left-text-border class="w-100" leftText="费用包含" v-model="routeInfo.description2" type="textarea"/>
            </div>
            <div class="d-center-start mt-4">
                <left-text-border class="w-100" leftText="重要提示" v-model="routeInfo.description3" type="textarea"/>
            </div>
            <div class="d-center-start mt-4">
                <left-text-border class="w-100" leftText="退改规则" v-model="routeInfo.description4" type="textarea"/>
            </div>
        </div>
        <div class="text-center">
          <el-button @click="submitForm" class="mt-4 btn-login">确定{{child ? '编辑' : '添加'}}</el-button>
        </div>
    </div>
</template>

<script>
import RichEditor from '../../../components/Editor/RichEditor'
import { mapActions } from 'vuex'
export default {
    name: 'packageTypeComp',
    components: { RichEditor },
    props:['discountDetail'],
    data () {
        return {
            routeInfo: {
                store_type: 8,
                itinerary_id: this.$route.query.discount,
                name: '',
                time: '',
                day_num: '',
                night_num: '',
                min: '',
                status: '1',
                description1: '',
                description2: '',
                description3: '',
                description4: '',
                sort: 1,
                'price1': '','price2': '','price3': '','price01': '','price02': '','price03': ''
            },
            nums: 0,
            fileProgressNum: 0,
            subscription: null,
            fileInfo:null,
        }
    },
    computed: {
        child () { return this.$route.query.child },
        routePrice() {
            return [
                {text: '门市价',noweek: 'price1',week: 'price01'},
                {text: '采购商价',noweek: 'price2',week: 'price02'},
                {text: '订单雨价',noweek: 'price3',week: 'price03'}
            ]
        }
    },
    watch: {
        discountDetail (newVal) {
            let info = newVal.itineraryDetailsArr.filter(v => v.id == this.child)[0]
            info.status = String(info.status)
            info.time = [info.start_time * 1000,info.end_time * 1000]
            info.itinerary_details_id = this.child
            this.routeInfo = {...info}
        }
    },
    methods: {
        ...mapActions(['addEditActiType']),
        // 富文本编辑器父子组件传参
        change(val) {
            this.$nextTick(_ => {
                this.ProductInfo.description1 = val
            })
        },
        //上传文件到七牛
        async chooseFile(e) {
            if (e.target.files[0].size > 5 * 1024 * 1024) {
            this._alert('文件超过5M，请选择5M以内的文件',null,'error')
            } else this.fileInfo = e.target.files[0];
            let next = res => this.fileProgressNum = Number((res.total.percent).toFixed(2));
            let complete = res => this.upItinerary('file',res.name);
            let error = res => console.log(res);
            let observable = await this.$GFUN.UploadFileToQiniu(this.fileInfo);
            this.subscription = observable.subscribe(next, error, complete);
        },
        upItinerary (type,saveText) {
            this.routeInfo.file = saveText
        },
        /*校验表单*/
        validateForm () {
            let arr = ['name','time','day_num','night_num','min','status','description1','description2','description3',
                'description4','price1','price2','price3','price01','price02','price03']
            for (let i = 0; i < arr.length; i++) {
                let v = arr[i];
                if (!this.routeInfo[v]) return {code: false,msg: '填写信息有误，请检查后提交'}
            }
            return { code: true, msg: '表单验证通过' }
        },
        async submitForm(type,saveText) {
            let result = this.validateForm()
            if (result.code) {
                this._confirm('确定提交么？',async () => {
                    this.routeInfo.start_time = this.routeInfo.start_time ? this.routeInfo.start_time : this.routeInfo.time[0].getTime() / 1000
                    this.routeInfo.end_time = this.routeInfo.end_time ? this.routeInfo.end_time : this.routeInfo.time[1].getTime() / 1000
                    delete this.routeInfo.time
                    this.routeInfo.description1 = await this.$GFUN.formatEditor(this.routeInfo.description1)
                    this.addEditActiType({
                        type: this.routeInfo.id > 0 ? 'edit' : 'add',
                        data: {...this.routeInfo }
                    })
                })
            } else this._alert(result.msg,null,'error')
        },
        toEleMsg () {
            window.open(this.ImgPreUrl + this.routeInfo.file,'_blank')
        }
    }
}
</script>

<style lang="scss" scoped>
.file {
    position: relative;
    display: inline-block;
    background: #0bafc9;
    border-radius: 4px;
    padding: 2px 12px;
    overflow: hidden;
    color: #fff;
    text-decoration: none;
    text-indent: 0;
    line-height: 24px;
    width: 70px;
    text-align: center
}
.file input {
    position: absolute;
    right: 0;
    top: 0;
    opacity: 0;
}
</style>